jQuery(function($){

    var keywordTypeahead = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
        queryTokenizer: Bloodhound.tokenizers.obj.whitespace,
        remote: {
            url: '/typeahead/query?limit=5&query=',
            replace: function(url, uriEncodedQuery) {
                url += uriEncodedQuery;
                if($('#master_search_categories').val() !== '') {
                    url += '&search_cat_id=' + encodeURIComponent($('#master_search_categories').val());
                }
                return url;
            },
            filter: function(response) {
                return response.keywords;
            }
        }
    });

    var productTypeahead = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
        queryTokenizer: Bloodhound.tokenizers.obj.whitespace,
        remote: {
            url: '/typeahead/query?limit=5&query=',
            replace: function(url, uriEncodedQuery) {
                url += uriEncodedQuery;
                if($('#master_search_categories').val() !== '') {
                    url += '&search_cat_id=' + encodeURIComponent($('#master_search_categories').val());
                }
                return url;
            },
            filter: function(response) {
                return response.products;
            }
        }
    });

    var utilityTypeahead = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
        queryTokenizer: Bloodhound.tokenizers.obj.whitespace,
        remote: {
            url: '/typeahead/query?limit=5&query=',
            replace: function(url, uriEncodedQuery) {
                url += uriEncodedQuery;
                if($('#master_search_categories').val() !== '') {
                    url += '&search_cat_id=' + encodeURIComponent($('#master_search_categories').val());
                }
                return url;
            },
            filter: function(response) {
                return response.utility;
            }
        }
    });

    // footer: function(data){
    //     return [
    //         '<div class="typeahead-footer tt-footer">',
    //             '<button class="typeahead-seeall" type="submit">See all results for "'+data.query+'"</button>',
    //         '</div>'
    //     ].join('\n');
    // }

    $('#master_search').typeahead({
            minLength: 3,
            highlight: true,
            hint: false,
            classNames: {
                input: 'typeahead-input',
                hint: 'typeahead-hint',
                menu: 'typeahead-menu',
                suggestion: 'typeahead-suggestion',
                //empty: '',
                open: 'typeahead-open',
                cursor: 'typeahead-selected',
                highlight: 'typeahead-highlight'
            }
        },
        {
            name: 'keywords',
            display: 'value',
            source: keywordTypeahead,
            limit: 5,
            templates: {
                suggestion: function(data) {
                    if(data.type == 'didyoumean') {
                        return [
                            '<div data-type="keyword">',
                                'Did you mean: <strong><em>',
                                $.trim(data.value),
                                '</em></strong>',
                            '</div>'
                        ].join('\n');
                    }
                    return [
                        '<div data-type="keyword">',
                            '<div class="tt-title">' + $.trim(data.value) + '</div>',
                        '</div>'
                    ].join('\n');
                }
            }
        },
        {
            name: 'products',
            display: 'value',
            source: productTypeahead,
            limit: 3,
            templates: {
                suggestion: function(data) {
                    return [
                        '<div data-type="product" data-url="'+data.url+'">',
                            '<div class="tt-title">',
                                data.value,
                                ((data.format !== '') ? ' <span class="tt-meta">&ndash; '+data.format+'</span>' : ''),
                            '</div>',
                            (data.author !== '') ? '<div class="tt-author tt-meta">By '+data.author+'</div>' : '',
                        '</div>'
                    ].join('\n');
                }
            }
        },
        {
            name: 'utility',
            display: 'value',
            source: utilityTypeahead,
            limit: 1,
            templates: {
                suggestion: function(data) {
                    return [
                        '<div data-type="keyword">',
                            '<div class="tt-title tt-seeall">See all results for "'+$.trim(data._query)+'"</div>',
                        '</div>'
                    ].join('\n');
                }
            }
        })
        .on('typeahead:selected', function(ev, data){
            var value = data;
            if(typeof data === 'object') {
                value = data.value;
                // if product, go to detail
                if(data.type == 'product' && data.url !== '') {
                    window.location = data.url;
                    return;
                }
            }
            // submit form otherwise
            if($.trim(this.value) !== '' && $.trim(value) !== ''){
                $(this).closest('form').submit();
            }
            return;
        });

    // global search filter
    $('#master_search_categories').on('change', function(){
        var $input = $('#master_search');
        var value  = $input.typeahead('val');

        // trigger typeahead change

        if(value !== '') {
            $input.typeahead('val', '')
                .typeahead('val', value)
                .focus();
        }
    }).trigger('change');
    $('#master_search').blur();

});